import { cx } from '../../components/ui';
import './room.css';

/** Thank-you, expired, invalid-link and connection-lost screens (light, on brand). */
export function EndScreen({
  tone,
  title,
  body,
  action,
}: {
  tone: 'done' | 'warn';
  title: string;
  body?: string;
  action?: { label: string; onClick: () => void };
}) {
  return (
    <div className="ev-room flex min-h-full items-center justify-center bg-(--ev-bg) px-4 py-16 text-(--ev-ink)">
      <div className="w-full max-w-lg rounded-3xl border border-(--ev-border) bg-white p-8 text-center shadow-sm sm:p-10">
        <div
          aria-hidden
          className={cx(
            'mx-auto flex h-14 w-14 items-center justify-center rounded-full text-2xl text-white',
            tone === 'done' ? 'ev-gradient' : 'bg-[#8a5a00]',
          )}
        >
          {tone === 'done' ? '✓' : '!'}
        </div>
        <h1 className="ev-display mt-6 text-2xl font-medium sm:text-3xl">{title}</h1>
        {body && <p className="mt-3 text-(--ev-muted)">{body}</p>}
        {action && (
          <button type="button" onClick={action.onClick} className="ev-gradient mt-8 rounded-2xl px-6 py-3 font-semibold text-white">
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
}
